<!--
* UIID: UI-DLB-RM-130
* UI Name: Matched Map List
* Modify Date: 2020/04/07
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.repositoryMatching.matchedMapListDialog.page_header')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon small class="mr-2" @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <div class="dialog-content div-form">
          <!-- [S]  Data Section-->
          <v-row class="ma-0 map-pb-search">
            <v-col cols="9" class="pa-0"></v-col>
            <v-col cols="3" class="pt-0 pb-0 pr-0 map-search">
              <v-text-field
                v-model="search"
                @input="onFilterFromMapList"
                @click:append="onFilterFromMapList"
                @keyup.enter="onFilterFromMapList"
                class="search-matched-map-list-button custom-form-component search-button search-popup"
                placeholder="Search"
                outlined
                dense
                solo
                hide-details
                append-icon="fas fa-search"
                height="30"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
              <v-data-table
                :fixed-header="true"
                :hide-default-footer="true"
                :headers="matched_map_table_header"
                :items="mapList"
                class="map-list-table pb-0"
                disable-pagination
                item-key="ROWID"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.ROWID"
                      v-bind:class="[item.ELEM_VAL == 'NOT USED' ? 'not_used_row' : '', item.EFSEGMENT_ID == 'BGM' ? 'bgm_row' : '']"
                    >
                      <td class="text-center matching-radio-col">
                        <input
                          type="radio"
                          v-model="selected_map"
                          :value="item.ROWID"
                          name="matched-map"
                          @click="selectMap(item)"
                        />
                      </td>
                      <td class="sender-col">{{ item.MSG_SNDR }}</td>
                      <td class="sender-col">{{ item.MSG_RCVR }}</td>
                      <td class="sender-col text-center">{{ item.MAP_MSG_ID }}</td>
                      <td class="layout-col text-center">
                        <a @click="openLayoutMatchingView(item)">{{$t('btn.common.view')}}</a>
                      </td>
                      <td class="matching-ratio-color text-center">{{ item.RST_RATIO }}</td>
                      <td class="map-col">{{ item.MAP_NAME }}</td>
                      <td class="flat-file-layout-col text-center">{{ item.FFL_FILE_NAME }}</td>
                    </tr>
                  </tbody>
                </template>
                <template v-slot:no-data>
                  <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </div>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right mr-4">
              <v-btn class="btn btn-delete" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
            </div>
          </v-col>
        </v-row>
        <!-- [E]  Data Section-->
      </v-card-text>
    </v-card>
  </dialog-drag>
</template>

<script>
/* globals Store */
import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import controlData from "../Data/asset-creation/data_control.json";
import IconSvg from "@/vue-caas/components/IconBase.vue";

import { mapState } from "vuex";

export default {
  components: {
    DialogDrag,
    IconSvg,
  },
  computed: {
    ...mapState("matching", {
      mapList: "mapList",
      matchedMapWindowParam: "matchedMapWindowParam",
    }),
  },
  // props: ['id', 'title', 'options', 'eventCb', 'closeDialog', 'dragStart', 'dragEnd', 'srm_item', 'reloadList'],
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    srm_item: Object,
    reloadList: Function,
  },
  name: "matched-map-list-dialog",
  data: () => ({
    search: "",
    selected_map: "",
    selectedMapParam: {
      header: ["LAY_PRCS_NO", "MAP_PRCS_NO"],
      data: [
        {
          LAY_PRCS_NO: "",
          MAP_PRCS_NO: "",
        },
      ],
    },
    searchParam: {
      header: ["LAY_PRCS_NO"],
      data: [
        {
          LAY_PRCS_NO: "",
        },
      ],
    },
    popupParam: {
      header: [
        "CUST_ID",
        "STR_SNDR",
        "STR_RCVR",
        "MSG_STD",
        "MSG_ID",
        "MSG_VER",
        "DAT_TYPE",
        "FR_DAT",
        "TO_DAT",
        "MSG_CNT",
        "PRCS_STS",
        "LAY_PRCS_NO",
        "ALIAS",
      ],
      data: [],
    },
    layoutMatchingViewArr: [],
    //matched_map_table_header : controlData[0].matched_map_table_header,
    matched_map_table_header: [
      { value: "selectCol", text: "Select" },
      { value: "sender", text: "Sender" },
      { value: "receiver", text: "Receiver" },
      { value: "message", text: "Message" },
      { value: "", text: "Layout" },
      { value: "matching_ratio", text: "Matching Ratio", width: "200px" },
      { value: "map", text: "Map" },
      { value: "flat_file_layout", text: "FlatFile Layout" },
    ],
  }),
  created() {
    this.queryMapList();
  },
  methods: {
    queryMapList() {
      console.log("--------- getqueryMapList ----------");
      this.searchParam.data[0].LAY_PRCS_NO = this.srm_item.LAY_PRCS_NO;
      Store.dispatch("matching/getMatchedMapList", this.searchParam).then(
        () => {
          console.log("--------- Finished to process ----------");
          this.setSelect();
        }
      );
    },
    setSelect() {
      let data = JSON.parse(JSON.stringify(this.mapList));
      let filtered = data.filter((item) => item.SELE_YN === "Y");
      this.selected_map = filtered[0].ROWID;
    },
    onFilterFromMapList(str) {
      Store.commit("matching/SET_STORE_MAPLIST_FILTER", { str: this.search });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    selectMap(item) {
      console.log("--------- saveSelectedMap ----------");
      this.selectedMapParam.data[0].LAY_PRCS_NO = item.ORG_LAY_PRCS_NO;
      this.selectedMapParam.data[0].MAP_PRCS_NO = item.ORG_MAP_PRCS_NO;
      // console.log("CHECK" + JSON.stringify(this.selectedMapParam));
      Store.dispatch("matching/saveSelectedMap", this.selectedMapParam).then(
        () => {
          console.log("--------- Finished to process ----------");
          this.reloadList();
          this.removeDialog({ id: this.id });
        }
      );
    },
    openLayoutMatchingView(item) {
      let index = this.findIndexItem(item, this.layoutMatchingViewArr, "id");
      if (index != null) {
        return;
      }

      this.popupParam.data[0] = {
        CUST_ID: `${this.matchedMapWindowParam.CUST_ID}`,
        STR_SNDR: `${this.matchedMapWindowParam.STR_SNDR}`,
        STR_RCVR: `${this.matchedMapWindowParam.STR_RCVR}`,
        MSG_STD: `${this.matchedMapWindowParam.MSG_STD}`,
        MSG_ID: `${this.matchedMapWindowParam.MSG_ID}`,
        MSG_VER: `${this.matchedMapWindowParam.MSG_VER}`,
        DAT_TYPE: `${this.matchedMapWindowParam.DAT_TYPE}`,
        FR_DAT: `${this.matchedMapWindowParam.FR_DAT}`,
        TO_DAT: `${this.matchedMapWindowParam.TO_DAT}`,
        PRCS_STS: `${this.matchedMapWindowParam.PRCS_STS}`,
        LAY_PRCS_NO: `${this.matchedMapWindowParam.LAY_PRCS_NO}`,
        ALIAS: `${this.matchedMapWindowParam.ALIAS}`,
      };
      this.popupParam.data[1] = {
        CUST_ID: `${item.MST_CUST_ID}`,
        STR_SNDR: `${item.MSG_SNDR}`,
        STR_RCVR: `${item.MSG_RCVR}`,
        MSG_STD: `${this.matchedMapWindowParam.MSG_STD}`,
        MSG_ID: `${item.MAP_MSG_ID}`,
        MSG_VER: `${item.MAP_MSG_VER}`,
        DAT_TYPE: ``,
        FR_DAT: ``,
        TO_DAT: ``,
        PRCS_STS: ``,
        LAY_PRCS_NO: `${item.CMP_LAY_PRCS_NO}`,
        ALIAS: `ALIAS_C${item.ROWID}`,
      };
      //this.params = [{"CUST_ID":"0041","STR_SNDR":"NYKS","STR_RCVR":"INTTRA","MSG_ID":"IFTMCS","MSG_VER":"UND99B","DAT_TYPE":"undefined","FR_DAT":"20200103","TO_DAT":"20200403","MSG_CNT":"","PRCS_STS":"","LAY_PRCS_NO":""},{"CUST_ID":"0041","STR_SNDR":"NYKS2","STR_RCVR":"INTTRA2","MSG_ID":"IFTMCS","MSG_VER":"UND99B","DAT_TYPE":"undefined","FR_DAT":"20200103","TO_DAT":"20200403","MSG_CNT":"","PRCS_STS":"","LAY_PRCS_NO":""}]
      this.params = this.popupParam.data;
      let querystring = "popup=true&";
      if (this.$vuetify.theme.isDark == true) {
        querystring += "theme=Dark";
      } else {
        querystring += "theme=Light";
      }
      var w = window.open(
        `/edimanager/LayoutMatchingView?${querystring}`,
        "_blank",
        "width=1825,height=804,left=100,top=100"
      );
      w.params = this.params;
      // 20218.7.13 203728 SPKA-153 close new window expired.
      w.newWindowExpire = true;
      this.layoutMatchingViewArr.push(item);
      w.theme = false;
      if (this.$vuetify.theme.isDark == true) {
        w.theme = this.$vuetify.theme.isDark;
      }
      w.closePopup = () => {
        let index = this.findIndexItem(item, this.layoutMatchingViewArr, "id");
        this.layoutMatchingViewArr.splice(index, 1);
        w.close();
      };
      if (typeof window.layoutMatchingViewWindow == "undefined") {
        //window.layoutMatchingViewWindow = {[item.id.toString()] : w.closePopup};
        window.layoutMatchingViewWindow = { close: w.closePopup };
      } else {
        // window.layoutMatchingViewWindow[item.id.toString()] = w.closePopup;
        window.layoutMatchingViewWindow["close"] = w.closePopup;
      }
      w.onbeforeunload = w.closePopup;
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == "undefined" ? "id" : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
  },
};
</script>

<style>
/* Remove unuse code
.tab-text {
  padding-left: 5px !important;
  justify-content: left !important;
}
.v-tabs.theme--dark > .v-item-group {
  background-color: #424242 !important;
}
.v-tabs.theme--dark > .v-item-group > .v-window.v-item-group {
  background-color: #424242 !important;
}
*/
.analyzed-layout-dialog.matched-map-list {
  width: 1075px !important;
  height: auto !important;
}
/* .analyzed-layout-dialog
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  width: 190px;
  margin: 0px !important;
} */
.analyzed-layout-dialog .v-text-field.search-matched-map-list-button.search-popup .v-input__control .v-input__slot{
  width: 100%;
  margin: 0px !important;
}
.analyzed-layout-dialog .search-button {
  margin: 0px !important;
}
.pos-search-box {
  padding: 0px;
  padding-left: 55px !important;
}
.btn-pt-10 {
  padding: 10px 0px 0px 0px !important;
}
.matched-map-list a {
  font-weight: bold;
  text-decoration: none;
  color: #0082ba !important;
}
.matched-map-list th {
  font-weight: 600;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
}
.matched-map-list table {
  /* border-right:1px solid  #d0d4dd !important; */
}
.matched-map-list table td {
  font-size: 11px;
  font-weight: normal;
  height: 30px;
}
.matched-map-list table td.matching-radio-col {
  padding-top: 6px;
}
.matched-map-list-dialog .data-table-section {
  width: 975px;
  height: 322px;
}
.matched-map-list .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 276px;
}
.v-application
  .analyzed-layout-dialog.matched-map-list
  .matched-map-list-search-section {
  margin-bottom: 10px !important;
}
.analyzed-layout-dialog.matched-map-list .dialog-header {
  background-color: #253c51;
}

.v-data-table.matched-map-list thead tr th span {
  font-size: 11px;
}

/* theme--light */
.theme--light .matched-map-list-dialog .data-table-section {
  background: #fafcff;
}
.theme--light.v-data-table.matched-map-list thead tr:last-child th {
  background-color: #e4e6e8;
  color: black !important;
  text-align: center !important;
  height: 25px !important;
}
.theme--light.v-data-table.matched-map-list td {
  border-top: none !important;
}
.theme--light .matched-map-list thead tr:first-child th {
  border-right: 1px solid #d0d4dd;
}
.theme--light .matched-map-list thead tr:first-child th:first-child {
  border-right: 1px solid #d0d4dd;
  border-left: 1px solid #d0d4dd !important;
}
.theme--light .matched-map-list .matching-ratio-color {
  color: #ba0070 !important;
  font-weight: bold;
}
.theme--light
  .matched-map-list.v-data-table.v-data-table--fixed-header
  thead
  tr
  th:first-child {
  border-bottom: 1px solid #d0d4dd !important;
}
.theme--light
  .matched-map-list.v-data-table.v-data-table--fixed-header
  thead
  tr
  th {
  border-top: 1px solid #d0d4dd !important;
}
/* theme--dark */
.theme--dark .matched-map-list-dialog .data-table-section {
  background: #292c35;
  border: none;
}
.theme--dark.v-data-table.matched-map-list thead tr:last-child th {
  background-color: #595b64;
  color: white !important;
  text-align: center !important;
  height: 25px !important;
}
.theme--dark .matched-map-list .matching-ratio-color {
  font-weight: bold;
  color: #f99dd4 !important;
}
/*08/20/2020 Matched Map List (UI-DLB-RM-130) Change the background color for search text field to #292C35. */
.theme--dark
  .matched-map-list-search-section
  .v-text-field.search-matched-map-list-button
  .v-input__control
  .v-input__slot {
  background-color: #292c35 !important;
}
.theme--dark
  .matched-map-list-search-section
  .search-matched-map-list-button.custom-form-component
  .v-input__slot
  .v-text-field__slot
  input {
  background-color: transparent !important;
}
</style>